export const MIN_2_CHARS = 'Min 2 characters are required';
